import React from 'react'
import { useParams } from 'react-router-dom';
import { Modal, Button } from 'antd';

const myFinUrl = 'https://myfin.derekdylu.com'

const EventFallback = () => {
  const { id } = useParams();

  return (
    <Modal
      title="How2split 已停止維護"
      open={true}
      footer={null}
      closable={false}
      centered
    >
      <div className="flex flex-col gap-2">
        <div>How2split 已停止維護，請改用全新的 myFin 繼續分帳。</div>
        <div className="text-xs text-gray-500">活動 ID: {id}</div>
        <Button type="primary" href={myFinUrl} target="_blank" rel="noopener noreferrer">
          前往 myFin
        </Button>
        <Button href="https://www.buymeacoffee.com/derekdylu" target="_blank" rel="noopener noreferrer">
          讚助我們 | Buy Me a Coffee
        </Button>
      </div>
    </Modal>
  )
}

export default EventFallback
